<mat-form-field floatLabel="never" class="custom-mat-form-field field-search-head">
  <mat-icon matPrefix svgIcon="ico-search" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
  <input matInput #inputSearch [placeholder]="_inputSearchPlaceholder" [(ngModel)]="_preSetInputText" name="input-search" (keyup)="onSearchInputKeyup($event,inputSearch.value)">
  <button mat-icon-button (click)="onClearSearchInput()" class="custom-mat-icon-button button-clean-search" [ngClass]="{'is--visible': _grid.inputSearchIsValid}">
    <mat-icon matSuffix svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
  </button>
</mat-form-field>
